let language = {
    BULK_ORDER_LIST_HEADER_PRODUCT: "Product",
    BULK_ORDER_LIST_HEADER_STORE_ORDER: "Store/Order #",
    BULK_ORDER_LIST_HEADER_SITE_PRICE: "Price",

    // 
    BULK_ORDER_LIST_SUMMARY_HEADER: "Combined Order Summary:",
    BULK_ORDER_LIST_SUMMARY_SUBTOTAL_CONTENT: "Subtotal:",
    BULK_ORDER_LIST_SUMMARY_TOTAL_CONTENT: "Total:",
    
    BULK_ORDER_LIST_COMBINE_ORDER_TITLE: "Combine Order",

    // 
    BULK_ORDER_LIST_PREBULK_ORDER_ITEM: "Prebulk Order Items",
    
    BULK_ORDER_LIST_BULK_ALL_TEXT: "Bulk All",

    //
    BULK_ORDER_LIST_CHECKOUT_BTN: "Checkout",
    BULK_ORDER_LIST_ALL_SELECT_CHECKBOX: "All select",

    BULK_ORDER_LIST_DISABLE_REASONS:"Reason for prohibition:"
};

export { language }